

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import {AppContainer} from 'react-hot-loader';

import 'bootstrap/dist/css/bootstrap.min.css';
//import 'bootswatch/dist/cerulean/bootstrap.min.css';

import './css/efp.css';

import { history, store /*, jwtInterceptor */, errorInterceptor  } from './_helpers';
import { App } from './App';


//enable interceptors for http requests
//jwtInterceptor();
errorInterceptor();


const render = () => {
	ReactDOM.render(
	<AppContainer>
		<Provider store={store}>
			<ConnectedRouter history={history}>
				<App />
			</ConnectedRouter>
		</Provider>
	</AppContainer>,
	document.getElementById('app')
	)
};

		
render();

if (module.hot) {
	  module.hot.accept(() => {render()})
}